import { REQUIRED_FEATURE_FLAGS } from 'helpers/sf_constants'

// Backend-column-sorting config for the lead integration logs grids. Mirrors the
// backend whitelists in lead_integration_logs_helper.rb. The frontend sends the
// column `dataField` verbatim as `sort_column`; the backend owns the
// dataField -> DB column remap and falls back to the default sort for anything
// not whitelisted.

// Admin (aggregate) Lead Integrations Logs — MvAdminLeadIntegrationStats.
export const ADMIN_INTEGRATION_LOGS_DEFAULT_SORT_COLUMN = 'total_requests'
export const ADMIN_INTEGRATION_LOGS_DEFAULT_SORT_DIRECTION = 'desc'
export const ADMIN_INTEGRATION_LOGS_SORTABLE_FIELDS = [
  'account_id',
  'account_name',
  'name',
  'integration_type',
  'total_requests',
  'successful_requests',
  'success_rate',
]

// Client (per-integration) Integration Logs — LeadIntegrationReqLog.
// `campaign_name` maps to campaigns.name on the backend when requested.
export const CLIENT_INTEGRATION_LOGS_DEFAULT_SORT_COLUMN = 'created_at'
export const CLIENT_INTEGRATION_LOGS_DEFAULT_SORT_DIRECTION = 'desc'
export const CLIENT_INTEGRATION_LOGS_SORTABLE_FIELDS = [
  'id',
  'success',
  'campaign_name',
  'created_at',
  'req_method',
  'res_status',
  'is_test',
  'posting_url',
]

// Backend column sorting is gated by a single shared flipper flag
// (`backend_column_sorting`) across pages. When off, the grids fall back to
// client-side sorting.
export function isIntegrationLogsBackendSortingEnabled(isFeatureFlagActive) {
  if (typeof isFeatureFlagActive !== 'function') return false
  return isFeatureFlagActive(REQUIRED_FEATURE_FLAGS.SF_FEATURE_FLAG_BACKEND_COLUMN_SORTING)
}

// Whether a column's `dataField` should expose a backend sort handle. Columns
// absent from the whitelist (JSON/computed/display-only) stay non-sortable.
export function isIntegrationLogsColumnBackendSortable(dataField, sortableFields) {
  return Boolean(dataField && sortableFields.includes(dataField))
}
